import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';

@Component({
  selector: 'page-tutorial-informes',
  templateUrl: 'tutorial-informes.html',
})
export class TutorialInformesPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    this.navCtrl.pop();
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-informes/tutorial-informes.ts